import styled, { css } from 'styled-components'
import { fontSize, fontWeight, size } from 'ui/themes/utils'

export const Services = styled.div`
  &&& {
    max-height: 180px;
    overflow-y: auto;
    padding-top: 16px;

    /* So scroll bar lines up with products scroll bar */
    margin-right: -15px;
    padding-right: 15px;

    /* Shadows to indiciate scroll */
    background: linear-gradient(#ffffff 33%, rgba(255, 255, 255, 0)),
      linear-gradient(rgba(255, 255, 255, 0), #ffffff 66%) 0 100%,
      radial-gradient(farthest-side at 50% 0, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0)),
      radial-gradient(farthest-side at 50% 100%, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0)) 0 100%;
    background-color: #ffffff;
    background-repeat: no-repeat;
    background-attachment: local, local, scroll, scroll;
    background-size: 100% 30px, 100% 30px, 100% 10px, 100% 10px;
  }
`

export const Service = styled.div`
  &&& {
    display: flex;
    justify-content: space-between;
    padding-top: 8px;

    ${({ disabled }) => disabled && css`
      opacity: 0.7;
    `}
  }
`

export const Label = styled.span`
  &&& {
    font-size: ${fontSize('md')};
    font-weight: ${fontWeight('lighter')};

    margin-right: ${size('margin', 'xs')};
  }
`
